import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__generation_price_get } from '@shared/dto/generation_price/DTO_REQUEST__generation_price_get';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { StateGenerationPrice } from './state_generation_price';

export const remote_generation_price_get_generation_price_by_hash = createAsyncThunkSafe(
  ENUM__network_event_client_to_server.GENERATION_PRICE_GET_GENERATION_PRICE_BY_HASH,
  async (requests: DTO_REQUEST__generation_price_get[]) => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_PRICE_GET_GENERATION_PRICE_BY_HASH, requests);
  },
);

export function init_remote_generation_price_get_generation_price_by_hash(builder: ActionReducerMapBuilder<StateGenerationPrice>) {
  builder
    .addCase(remote_generation_price_get_generation_price_by_hash.pending, (state, action) => {
      let requests = action.meta.arg;

      for (let request of requests) {
        state.generation_prices_by_hash_loading_in_progress_set.add(request.hash);
      }

      //need for force re-render
      state.generation_prices_by_hash_loading_in_progress_set = new Set(state.generation_prices_by_hash_loading_in_progress_set);
    })
    .addCase(remote_generation_price_get_generation_price_by_hash.rejected, (state, action) => {})
    .addCase(remote_generation_price_get_generation_price_by_hash.fulfilled, (state, action: PayloadAction<void>) => {});
}
